import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';
import Header from '../components/cafe/Header';
import CoffeeVarient from '../components/cafe/CoffeeVarient';
import AboutUs from '../components/cafe/AboutUs';
import CoffeeView from '../components/cafe/CoffeeView';
import CoffeeTime from '../components/cafe/CoffeeTime';
import Testimonial from '../components/cafe/Testimonial';
import FAQ from '../components/cafe/FAQ';
import Footer from '../components/cafe/Footer';

export default function CafePage() {
  const navigate = useNavigate();

  useEffect(()=> {
    window.scrollTo(0,0);
  },[]);

  return (
    <div className="min-h-screen w-full bg-neutral-950 font-sans relative">
      {/* Floating Back Button */}
      <button 
        onClick={() => navigate('/portfolio')}
        className="fixed bottom-6 right-6 z-[100] bg-white/10 hover:bg-white/20 backdrop-blur-md border border-white/20 text-white px-6 py-3 rounded-full font-semibold flex items-center gap-2 transition-all shadow-2xl cursor-pointer"
        style={{ fontFamily: "'Inter', sans-serif" }}
      >
        <FiArrowLeft /> Head back to Hostfig.com
      </button>

      <Header />
      <CoffeeVarient />
      <AboutUs />
      <CoffeeView />
      <CoffeeTime />
      <Testimonial />
      <FAQ />
      <Footer />
    </div>
  );
}